// extracted by mini-css-extract-plugin
export default {"main":"HeaderSection_main__dayLp","groupContent":"HeaderSection_groupContent__YT3zz","text":"HeaderSection_text__LqGyU"};